// Domain types for the staff-only ops tooling (Tier 5.7). Camel-cased shapes
// the UI consumes; the api layer maps the snake_case envelope.

export interface OpsFirmSummary {
  id: string;
  name: string;
}

export interface OpsUser {
  id: number;
  name: string;
  email: string;
  accountType: "firm" | "individual";
  role: "staff" | "team_leader" | "country_director" | null;
  firm: OpsFirmSummary | null;
  isActive: boolean;
  isStaff: boolean;
  isPlatformAdmin: boolean;
  lastLogin: string | null;
  dateJoined: string | null;
}

export interface ListMeta {
  count: number;
  next: string | null;
  previous: string | null;
}

export interface ImpersonationSession {
  id: string;
  operator: OpsUser;
  target: OpsUser;
  startedAt: string;
  endedAt: string | null;
  operatorIp: string | null;
}

export interface ImpersonateResult {
  access: string;
  refresh: string;
  user: OpsUser;
  session: ImpersonationSession;
}

export interface LoginEvent {
  id: string;
  loggedAt: string;
  loginType: string;
  ipAddress: string | null;
  sessionKey: string;
}

export type JobStatus = "RUNNING" | "SUCCESS" | "FAILED";

export interface JobRun {
  id: string;
  jobName: string;
  trigger: string;
  triggeredByEmail: string | null;
  status: JobStatus;
  startedAt: string;
  finishedAt: string | null;
  durationMs: number | null;
  recordsProcessed: number;
  summary: string;
  error: string;
}

export interface JobSpec {
  name: string;
  label: string;
  description: string;
  cadence: string;
  manual: boolean;
  lastRun: JobRun | null;
}

export interface EntityUser {
  id: number;
  name: string;
  email: string;
  role: string | null;
  isActive: boolean;
  lastLogin: string | null;
}

export interface EntityDetail {
  id: string;
  name: string;
  email: string;
  createdAt: string;
  userCount: number;
  clientCount: number;
  documentCount: number;
  users: EntityUser[];
}

export interface CsedAuditRow {
  client: string;
  taxYear: string;
  form: string;
  calculatedCsed: string | null;
  irsCsed: string | null;
  primaryPractitioner: string;
}

export const REPORT_KINDS = [
  { key: "members", label: "Members report" },
  { key: "multiuser", label: "Multi-user report" },
  { key: "cpacharge", label: "CPA Charge report" },
  { key: "transcript-discrepancy", label: "Transcript discrepancies" },
  { key: "esignature", label: "E-signature report" },
] as const;
